import React, { Component } from 'react';
import './element-iframe-properties.css';
import {
  ColorPicker
} from '../../components';
import PreferenceRequiredInteraction
  from "../../components/preference-required-interaction/preference-required-interaction";

export default class ElementIframeProperties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "content": this.props.content
    }

    this.onContentTitleChange = this.onContentTitleChange.bind(this);
    this.onBackgroundColorChange = this.onBackgroundColorChange.bind(this);
    this.onPaddingTopChange = this.onPaddingTopChange.bind(this);
    this.onPaddingBottomChange = this.onPaddingBottomChange.bind(this);
    this.onWidthChange = this.onWidthChange.bind(this);
    this.onHeightChange = this.onHeightChange.bind(this);
  }

  formatUrl(url) {
    if (url.indexOf("youtube.com/watch") > -1) {
      var res = url.split("=");
      var url = "https://www.youtube.com/embed/"+res[1];
    }
    return url;
  }

  onUrlChange(e) {
    var content = this.state.content;
    content.url = e.currentTarget.value !== "" ? e.currentTarget.value : content.url;
    content.url = this.formatUrl(content.url);
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onContentTitleChange(e) {
    var content = this.state.content;
    content.content_title = e.currentTarget.value !== "" ? e.currentTarget.value : content.content_title;

    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onBackgroundColorChange(color) {
    var content = this.state.content;
    content.background_color = color;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onPaddingTopChange(e) {
    var content = this.state.content;
    content.padding_top = e.currentTarget.value !== "" ? e.currentTarget.value : content.padding_top;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onPaddingBottomChange(e) {
    var content = this.state.content;
    content.padding_bottom = e.currentTarget.value !== "" ? e.currentTarget.value : content.padding_bottom;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onWidthChange(e) {
    var content = this.state.content;
    content.width = e.currentTarget.value !== "" ? e.currentTarget.value : content.width;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onHeightChange(e) {
    var content = this.state.content;
    content.height = e.currentTarget.value !== "" ? e.currentTarget.value : content.height;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  render() {
    var content = this.state.content;
    var labels = this.props.labels;

    return (<div className="rdp-element-video-properties">
      <ul className="rdp-composer-element-edit-tabs">
        <li className="rdp-composer-element-edit-tabs-item active">{labels.elements.common_settings.label_tab_settings}</li>
      </ul>
      <div className="rdp-composer-element-edit-body">
        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_iframe.settings_label_content_title}:</span>
        <input type="text" className="rdp-composer-element-edit-input" onChange={(e) => this.onContentTitleChange(e)} defaultValue={content.content_title}></input>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_iframe.settings_label_webview_url}:</span>
        <input type="text" className="rdp-composer-element-edit-input" onChange={(e) => this.onUrlChange(e)} defaultValue={content.url}></input>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_iframe.settings_label_background_color}</span>
        <ColorPicker labels={this.props.labels} color={content.background} onChange={this.onBackgroundColorChange} />

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_iframe.settings_label_margin_top}</span>
        <input type="number" className="rdp-composer-element-edit-input px" onChange={(e) => this.onPaddingTopChange(e)} defaultValue={content.padding_top}></input>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_iframe.settings_label_margin_bottom}</span>
        <input type="number" className="rdp-composer-element-edit-input px" onChange={(e) => this.onPaddingBottomChange(e)} defaultValue={content.padding_bottom}></input>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_iframe.settings_label_width}</span>
        <input type="number" className="rdp-composer-element-edit-input px" onChange={(e) => this.onWidthChange(e)} defaultValue={content.width}></input>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_iframe.settings_label_height}</span>
        <input type="number" className="rdp-composer-element-edit-input px" onChange={(e) => this.onHeightChange(e)} defaultValue={content.height}></input>

        <PreferenceRequiredInteraction
          title={labels.elements.settings.preference_required_interaction.title}
          label={labels.elements.settings.preference_required_interaction.label}
          labels={labels}
          content={content}
          onContentChange={c => {
            this.setState({ content: c });
            this.props.onContentChange(c);
          }}
        />
      </div>
    </div>);
  }
}
